import {
  Component,
  OnInit,
  OnChanges,
  ChangeDetectionStrategy,
  SimpleChanges,
  ViewChild,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { ActivatedRoute } from '@angular/router';
import { ResponseTableModel } from 'src/app/domain/models/response-table.model';
import { HistoryDto } from 'src/app/domain/models/dto/history.dto';
@Component({
  selector: 'app-table-clients-log-admin',
  templateUrl: './table-log.component.html',
  styleUrls: ['./table-log.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableLogComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input() data: ResponseTableModel<HistoryDto[]>;
  @Input() displayedColumns: string[];
  @Input() corporateAccountId: number;

  selection = new SelectionModel<any>(true, []);
  public dataSource: MatTableDataSource<HistoryDto>;
  @Input() pageNumber: number = 0;
  @Input() pageSize: number = 10;
  @Input() totalElements: number;

  tenant: string = '';
  isLoading: boolean = false;

  @Output() pageChange = new EventEmitter<{
    pageNumber: number;
    pageSize: number;
  }>();

  constructor(
    private readonly route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
  }

  ngAfterViewInit(): void {
    if (this.data && this.data.content && this.data.content.length > 0) {
      this.initializeDataSource();
      this.initializeTableSort();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      this.initializeDataSource();
      this.initializeTableSort();
      this.cdr.detectChanges();
    }

    if (changes.totalElements) {
      this.initializePaginator();
      this.cdr.detectChanges();
    }
  }

  initializeTableSort() {
    if (this.sort && this.dataSource) {
      this.sort.active = 'date';
      this.sort.direction = 'desc';
      this.dataSource.sort = this.sort;
    }
  }

  private initializePaginator() {
    if (this.paginator) {
      this.paginator.length = this.totalElements || 0;
      this.paginator.pageIndex = this.pageNumber;
      this.paginator.pageSize = this.pageSize;

      this.paginator._intl.getRangeLabel = (
        page: number,
        pageSize: number,
        length: number
      ) => {
        if (length === 0 || pageSize === 0) {
          return '0 de ' + length;
        }

        length = Math.max(length, 0);
        const startIndex = page * pageSize;

        const endIndex =
          startIndex < length
            ? Math.min(startIndex + pageSize, length)
            : startIndex + pageSize;
        return 'Exibindo ' + endIndex + ' de ' + length + ' registros';
      };
    }
  }

  private initializeDataSource() {
    const data = this.data?.content || [];
    this.dataSource = new MatTableDataSource(data as any);

    if (this.paginator) {
      this.paginator.length = this.totalElements || 0;
      this.paginator.pageIndex = this.pageNumber;
      this.paginator.pageSize = this.pageSize;

      this.paginator._intl.getRangeLabel = (
        page: number,
        pageSize: number,
        length: number
      ) => {
        if (length === 0 || pageSize === 0) {
          return '0 de ' + length;
        }

        length = Math.max(length, 0);
        const startIndex = page * pageSize;

        const endIndex =
          startIndex < length
            ? Math.min(startIndex + pageSize, length)
            : startIndex + pageSize;
        return 'Exibindo ' + endIndex + ' de ' + length + ' registros';
      };
    }
  }

  chanePageEvent(event: { pageIndex: number; pageSize: number }) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;

    sessionStorage.setItem('clients-page-size', this.pageSize.toString());

    this.pageChange.emit({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    });
  }

  onRowToggled(row: any) {
    this.selection.toggle(row);
  }

  isAllSelected() {
    return this.selection.selected?.length == this.dataSource.data.length;
  }

  toggleAll() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.selection.select(...this.dataSource.data);
    }
  }
}
